export enum TransactionType {
    WIRE = "1"
}